<template>
  <div
    v-if="!authenticated || !hasActiveSubscription"
    
  >
    <div class="subscribe-ad-card-container">
      <div class="subscribe-ad-card md:w-99 md:px-10 flex items-center">
        <img
          src="@/assets/images/logo_Index_acta.png"
          class="md:w-36 w-24 mr-5 mb-4 content-center sticky top-3"
        />
        <div class="dialog-c-text">
          <p class="md:text-sm mb-6 text-left">
            Consultez les informations
            <span class="bold orange">mises à jour en temps réel</span> sur les
            produits commercialisés en France,
            <span class="bold">phytopharmaceutiques, macro-organismes,</span>
            produits utilisables en
            <span class="vert bold" style="color: #a8c30f"
              >agriculture biologique, biocontrôle</span
            ><span class="bold">, biocides agricoles… </span>
          </p>
          <ul class="liste-fleche text-left md:text-sm">
            <li>Plus de <span class="bold orange">4000 solutions</span></li>
            <li>
              Des<span class="bold orange">
                informations complètes et fiables</span
              >
            </li>
            <li>
              Un<span class="bold orange"> moteur de recherche performant</span>
            </li>
            <li>
              Un<span class="bold orange">
                décryptage des actualités règlementaires</span
              >
            </li>
            <li>
              Une<span class="bold orange">
                mise en favori de vos recherches</span
              >
            </li>
          </ul>
        </div>
      
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SubscriptionAdCard",
  computed: {
    authenticated() {
      return this.$store.getters["authent/isAuthenticated"];
    },

    hasActiveSubscription() {
      return this.$store.getters["authent/hasActiveSubscription"];
    },
  },
};
</script>
